import React, {Component} from 'react';

import {
    FormControlLabel,
    Switch,
} from "@mui/material";


class SwitchButton extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.props.checked !== nextProps.checked
    }

    handleChange() {
        const { id, onChange } = this.props;
        onChange(id, null);
    }

    render() {
        const { label, checked } = this.props;
        const { handleChange } = this;

        return (
            <FormControlLabel
                control={<Switch checked={checked} />}
                label={label}
                onChange={handleChange}
            />
        );
    }
}

SwitchButton.defaultProps = {
    label: "on",
    checked: true,
    onChange: function() {  },
}

export default SwitchButton;
